import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { ReviewItem, ReviewSummary, RatingBadge } from "@/components/EventReviews";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

export const AdminEventReviews = ({ canEdit }: { canEdit: boolean }) => {
  const { t } = usePrefs();
  const [s, setS] = useState<ReviewSummary | null>(null);
  const load = () => api.get("/admin/event-reviews").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const del = async (id: string) => {
    if (!window.confirm(t("rev.confirmDelete"))) return;
    try { await api.delete(`/admin/event-reviews/${id}`); toast.success(t("rev.done.delete")); load(); } catch (e) { toast.error(errorText(e, t)); }
  };
  const delReply = async (id: string) => {
    if (!window.confirm(t("rp.confirmDelete"))) return;
    try { await api.delete(`/admin/event-reviews/${id}/reply`); toast.success(t("rp.deleted")); load(); } catch (e) { toast.error(errorText(e, t)); }
  };
  if (!s) return null;
  return (
    <section data-testid="admin-event-reviews" className="space-y-3">
      <div className="flex flex-wrap items-center gap-3"><h2 className="font-display text-xl font-black">{t("er.adminTitle")}</h2><RatingBadge s={s} testId="admin-event-reviews-summary" /></div>
      {s.count === 0 && <p className="text-sm text-muted-foreground" data-testid="admin-event-reviews-empty">{t("er.empty")}</p>}
      <div className="grid gap-2 md:grid-cols-2 items-start">
        {s.items.map((r) => (
          <div key={r.review_id} className="relative min-w-0">
            <ReviewItem r={r} showEvent>
              {r.venue_name_ar && <p className="text-[11px] text-muted-foreground truncate pe-9">{r.venue_name_ar}</p>}
              {canEdit && r.reply && <button data-testid={`admin-review-reply-delete-${r.review_id}`} onClick={() => delReply(r.review_id)} className="mt-1 text-xs font-bold text-rose-600">{t("rp.adminDelete")}</button>}
            </ReviewItem>
            {canEdit && <button data-testid={`admin-event-review-delete-${r.review_id}`} onClick={() => del(r.review_id)} className="absolute bottom-3 end-3 h-8 w-8 grid place-items-center rounded-full bg-rose-50 text-rose-600"><Trash2 className="h-4 w-4" /></button>}
          </div>
        ))}
      </div>
    </section>
  );
};
